module.exports = {
  channelName: 'Channel name',
  simQueryPlaceholder: 'Please enter channel name',
  shippingType: 'Shipping type',
  destinationDistribution: '配送先コード',
  chargingMethod: 'Charging method',
  acceptableGoods: 'Acceptable goods',
  settlementWeightRoundingRules: 'Settlement weight rounding rules',
  creator: '作成者',
  bubbleCountingRatio: 'Bubble counting ratio',
  bubbleSplittingRatio: 'Bubble splitting ratio',
  multipleBoxesCalculationRules: 'Multiple boxes calculation rules',
  singleBoxLowestBillableWeight: 'Single box lowest billable weight',
  newChannel: 'New channel',
  editChannel: 'Edit channel',
  lookChannel: 'Look channel',
  weightInfo: 'Weight Info',
  channelNameNoEmpty: 'Channel name can not empty!',
  shippingTypeNoEmpty: 'Shipping type can not empty!',
  destinationDistributionNoEmpty: '配送先コード',
  chargingMethodNoEmpty: 'Charging method can not empty!',
  bubbleCountingRatioNoEmpty: 'Bubble counting ratio can not empty!',
  bubbleSplittingRatioNoEmpty: 'Bubble splitting ratio can not empty!',
  singleBoxLowestBillableWeightNoEmpty: 'Single box lowest billable weight can not empty!',
  multipleBoxesCalculationRulesNoEmpty: 'Multiple boxes calculation rules can not empty!',
  settlementWeightRoundingRulesNoEmpty: 'Settlement weight rounding rules can not empty!',
  acceptableGoodsNoEmpty: 'At least select one acceptable good!',
  editExistChannel: 'A quotation has been generated by the channel. Do you want to refresh the channel information of the quotation?',
  notEditName: 'This channel has been imported into the quotation, and the channel name cannot be modified.',
  activeState: 'Active State',
  enable: 'Enable',
  disable: 'Disable',
  enableSucceed: 'Channel enabled successfully!',
  disableSucceed: 'Channel disabled successfully!',
  cannotActive: 'No data to edit.',
  exportQuotation: '見積のエクスポート',
  printQuotation: '見積書の印刷',
  quotationValidityPeriod: '見積有効期間',
  quotationLabel: '見積書ラベル',
  previewQuotation: '見積のプレビュー',
  longTerm: '長期有効',
  addOrder: '新規注文',
  revokeTheApprovalForm: '請求書の取消',
  revokeOutboundShipment: '出庫取消',
  containerNo: 'コンテナ番号',
  cannotDelete: 'It is not allowed to delete channels that have already generated quotations!'
}
